/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState, useEffect } from 'react';
import { Dialog, CopyTextField, Checkbox, MessageBar, Dropdown, Language } from '@eta/components';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, ProgressIndicator, Icon, MessageBarType, IDropdownOption, ActionButton, Spinner, SpinnerSize } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import './RegenerateSecrets.scss';
import { Spacer } from '../../../common/component/Spacer';
import { UIHelpers } from '../../../helpers/UIHelpers';
import { ServiceCreator } from '../../../Services/ClientProxy/ServiceFactory';
import { ClientSecretModel, RegenerateDeviceCredentialsDto } from '../../../Services/POS/PosService';

export interface RegenerateSecretsProps {
    hidden: boolean;
    onClose: () => void;
    onSave: (status: boolean) => void;
    currentLanguage: Language;
    id: number;
    generatedSecrets?: ClientSecretModel|undefined;
    newMode?: boolean;
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const RegenerateDeviceSecrets: FC<PropsFromRedux & RegenerateSecretsProps> = (
    props: PropsFromRedux & RegenerateSecretsProps
) => {
    const { t } = useTranslation(['pos']);
    const { hidden, onClose, onSave, currentLanguage,id,generatedSecrets, newMode } = props;
    const [currentSecretData, setcurrentSecretData] = useState<any | undefined>();
    const [disableCheckbox, setdisableCheckbox] = useState<boolean>(true);
    const [loading, setloading] = useState<boolean>(false);
    const [error, setError] = useState<string>();

    const [, setclientIDCopied] = useState<boolean>(false);
    const [, setclientSecret1Copied] = useState<boolean>(false);
    const [, setclientSecret2Copied] = useState<boolean>(false);
    const [expiryInYearsLookups, setExpiryInYearsLookups] = useState<number | undefined>(undefined);
    const [OldexpiryInHoursLookups, setOldexpiryInHoursLookups] = useState<string | undefined>(undefined);
    const [OldexpiryInHoursLookupsName, setOldexpiryInHoursLookupsName] = useState<string | undefined>(undefined);
    const [reGenerate, setReGenerate] = useState<boolean>(false);
    const [expireDate, setexpireDate] = useState<Date>();
    const [disableGenerate, setdisableGenerate] = useState<boolean>(true);

    const ExpiryInHours: IDropdownOption[] = [
        { key: '0', text: t('Immediately') },
        { key: '2', text: t('After_2hours') },
        { key: '8', text: t('After_8hours') },
        { key: '24', text: t('After_24hours') },
        { key: '72', text: t('After_72hours') },
    ];

    const ExpiryInYears: IDropdownOption[] = [
        { key: 1, text: t('1 Year') },
        { key: 2, text: t('2 Year') },
        { key: 3, text: t('3 Year') },
    ];

    const setSecret = async () => {
        try {
            setloading(true);
            const client = ServiceCreator.getPosManagementPublicClient();
            const dto = new RegenerateDeviceCredentialsDto();
            dto.revokeDuration = Number(OldexpiryInHoursLookups);
            dto.credentialExpiryDate = expireDate;
            const response = await client.regenerateDeviceCredentials(id, dto);
            setcurrentSecretData(response);
        } catch(ex){ 
            const exp = ex as any;
            setError(exp?.response?.message.toString());
        }finally{
            setloading(false);
        }
    };

    const onGenerateSecret = () => {
        setReGenerate(true);
        setdisableGenerate(true);
        setSecret();
        if (expiryInYearsLookups) {
            const date = new Date();
            date.setFullYear(date.getFullYear() + expiryInYearsLookups);
            setexpireDate(date);
        }
    };

    useEffect(() => {
        if (generatedSecrets) {
            setcurrentSecretData(generatedSecrets);
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            setexpireDate(date);
            setReGenerate(true);
        }
    }, [generatedSecrets]);

    useEffect(() => {
        if (!hidden) {
            // setloading(true);
            // setcurrentSecretData(new UpdateSystemDelegateResponseDto());
            setdisableCheckbox(true);
            setError('');
        }
    }, [hidden]);

    useEffect(() => {
        if (currentSecretData?.clientID) {
            setReGenerate(true);
        }
    }, [currentSecretData?.clientID]);

    useEffect(() => {
        if (OldexpiryInHoursLookups && expiryInYearsLookups)
            setdisableGenerate(false);
    }, [OldexpiryInHoursLookups, expiryInYearsLookups]);

    return (
        <Dialog
            containerClassName={
                reGenerate
                    ? 'hideDismiss regenerate_dialog'
                    : 'regenerate_dialog'
            }
            hidden={hidden}
            onDismiss={() => {
                if (!reGenerate) onClose();
            }}
            maxWidth={550}
            title={
                !reGenerate ? (
                    <>
                        <Icon iconName="Redo" /> {t('reGenerate')}
                    </>
                ) : (
                    <>
                        <Icon iconName="SkypeCircleCheck" />{' '}
                        {t(newMode ? 'registered' : 'secretGenerate')}
                    </>
                )
            }
            Footer={
                !reGenerate && (
                    <div className="btn_GenerateSecret">
                        <ActionButton
                            className="btn-Generate"
                            onClick={() => onGenerateSecret()}
                            text={t('Generate')}
                            disabled={disableGenerate || loading}
                        />
                    </div>
                )
            }
        >
            <div className="container-fluid RegenerateSecrets">
                <MessageBar
                    messageBarType={MessageBarType.blocked}
                    isMultiline={false}
                    onDismiss={() => setError('')}
                    truncated
                >
                    {error}
                </MessageBar>
                {!reGenerate && (
                    <div className="regenerateSecret_Options">
                        <Dropdown
                            label={t('currSecretExp')}
                            options={ExpiryInHours ?? []}
                            selectedKey={OldexpiryInHoursLookups}
                            required
                            onChange={(_, option) => {
                                setOldexpiryInHoursLookups(
                                    option?.key as string
                                );
                                setOldexpiryInHoursLookupsName(
                                    option?.text as string
                                );
                            }}
                        />
                        <Dropdown
                            label={t('newSecretExp')}
                            options={ExpiryInYears ?? []}
                            selectedKey={expiryInYearsLookups}
                            required
                            onChange={(_, option) => {
                                const date = new Date();
                                date.setFullYear(
                                    date.getFullYear() + (option?.key as number)
                                );
                                setexpireDate(date);
                                setExpiryInYearsLookups(option?.key as number);
                            }}
                        />
                        {loading && (
                            <div className="spinnerOnButtonCLick">
                                <Spinner
                                    size={SpinnerSize.large}
                                    label={t('loading')}
                                    ariaLive="assertive"
                                    labelPosition="bottom"
                                />
                            </div>
                        )}
                    </div>
                )}

                {reGenerate && (
                    <>
                        <div className="heading">
                            <p>{t('Secret1')}</p>
                            <Spacer direction="vertical" size={10} />
                            {OldexpiryInHoursLookupsName && (
                                <div className="contain_RegenerateSecrets">
                                    <p className='inline-item'>{`${t('secretexpire')} `}</p>
                                    <span>{OldexpiryInHoursLookupsName}</span>
                                </div>
                            )}
                            <div className="contain_RegenerateSecrets">
                                <p className='inline-item'>{`${t('newsecretexpire')} `}</p>
                                <span>
                                    {UIHelpers.FormatDatePickerValue(
                                        expireDate,
                                        currentLanguage?.langIso4
                                    )}
                                </span>
                            </div>

                            <Spacer direction="vertical" size={10} />
                        </div>
                        <div className="bodyLine first ClientDetails">
                            <CopyTextField
                                label={t('ClientID')}
                                value={currentSecretData?.clientID}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientIDCopied(true)}
                            />
                        </div>
                        <div className="bodyLine ClientDetails">
                            <CopyTextField
                                label={t('ClientSecret1')}
                                value={currentSecretData?.clientSecretOne}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientSecret1Copied(true)}
                            />
                        </div>
                        <div className="bodyLine ClientDetails">
                            <CopyTextField
                                label={t('ClientSecret2')}
                                value={currentSecretData?.clientSecretTow}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientSecret2Copied(true)}
                            />
                        </div>
                        <div className="bodyLine checkbox">
                            <Checkbox
                                onChange={(_, v) =>
                                    setdisableCheckbox(!v ?? true)
                                }
                            />
                            <span className="checkLabel">
                                {t('confirmCheckbox')}
                            </span>
                        </div>
                        <div className="bodyLine btn-addErp doneBtn">
                            <Spacer direction="vertical" size={10} />
                            {loading ? (
                                <div>
                                    <ProgressIndicator />
                                </div>
                            ) : null}
                            <PrimaryButton
                                onClick={() => onSave(true)}
                                disabled={disableCheckbox}
                            >
                                {t('Done')}
                            </PrimaryButton>
                        </div>
                        {loading && (
                            <div className="spinnerOnButtonCLick">
                                <Spinner
                                    size={SpinnerSize.large}
                                    label={t('loading')}
                                    ariaLive="assertive"
                                    labelPosition="bottom"
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </Dialog>
    );
};

export default connector(RegenerateDeviceSecrets);